import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    meta:{title:'登录 - 视频上传系统'},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login/Login.vue")
  },
  {
    path: "/",
    name: "Index/",
    meta:{title:'首页 - 视频上传系统'},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/index/Index.vue")
  },
  {
    path: "/index",
    name: "Index",
    meta:{title:'首页 - 视频上传系统'},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/index/Index.vue")
  },
  {
    path: "/upload",
    name: "Upload",
    meta:{title:'上传视频 - 视频上传系统'},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/mutil/video.vue")
  },
  {
    path: "/list",
    name: "List",
    meta:{title:'视频列表 - 视频上传系统'},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/list/video.vue")
  },
  {
    path: "/setting",
    name: "Setting",
    meta:{title:'设置 - 视频上传系统'},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/setting/setting.vue")
  },
  {
    path: "/account",
    name: "Account",
    meta:{title:'帐号管理 - 视频上传系统'},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/setting/account.vue")
  },
  {
    path: "*",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/index/Index")
  },
  
];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});


export default router;
